module.exports = __webpack_public_path__ + "img/wrapped_bath.e753f134.jpg";